// extracted by mini-css-extract-plugin
export default {"table":"ReportsTable_table__cmOxQ","tableCell":"ReportsTable_tableCell__GphR6"};